import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";

import LandingPage from 'pages/LandingPage/LandingPage';
import SignInPage from 'pages/SignInPage/SignInPage';
import CategoriesPage from 'pages/CategoriesPage/CategoriesPage';
import SubcategoriesPage from 'pages/SubcategoriesPage/SubcategoriesPage';
import QuestionsPage from 'pages/QuestionsPage/QuestionsPage';
import QuestionPage from 'pages/QuestionsPage/QuestionPage';
import UsersPage from 'pages/UsersPage/UsersPage';
import UserPage from 'pages/UsersPage/UserPage';
import RatingListPage from 'pages/RatingPage/RatingListPage';
import NotificationListPage from 'pages/NotificationPage/NotificationListPage';
import NotificationItemPage from 'pages/NotificationPage/NotificationItemPage';
import PrivateRoute from './PrivateRoute';

import * as ROUTES from 'constants/routes';
import { AuthProvider } from "AuthProvider";

const WebNavigation = () => {
  return (
    <AuthProvider>
      <Router basename="/build">
        <Switch>
          <PrivateRoute exact path={ROUTES.LANDING} component={LandingPage} />
          <Route basename="/build" exact path={ROUTES.SIGN_IN} component={SignInPage} />
          <PrivateRoute path={ROUTES.CATEGORIES} component={CategoriesPage} />
          <PrivateRoute path={ROUTES.SUBCATEGORIES} component={SubcategoriesPage} />
          <PrivateRoute exact path={ROUTES.QUESTIONS} component={QuestionsPage} />
          <PrivateRoute exact path={`${ROUTES.QUESTIONS}/:id`} component={QuestionPage} />
          <PrivateRoute exact path={ROUTES.USERS} component={UsersPage} />
          <PrivateRoute exact path={`${ROUTES.USERS}/:id`} component={UserPage} />
          <PrivateRoute exact path={ROUTES.RATING} component={RatingListPage} />
          <PrivateRoute exact path={ROUTES.NOTIFICATION} component={NotificationListPage} />
          <PrivateRoute exact path={`${ROUTES.NOTIFICATION}/:id`} component={NotificationItemPage} />
        </Switch>
      </Router>
    </AuthProvider>
  );
};

export default WebNavigation;
